export default __webpack_public_path__ + "static/consumer-awards-bma-generic-a13e8b50eb13645277e3215b670e5ad2.png";